import { SxProps } from "@mui/material";

// Estilo padronizado para modais da área administrativa, alinhado ao novo visual
export const adminModalSx: SxProps = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: 600 },
  maxHeight: "90vh",
  overflow: "auto",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 0,
};

// Botão primário consistente (azul) para ações principais
export const adminButtonPrimarySx: SxProps = {
  bgcolor: "primary.main",
  color: "primary.contrastText",
  fontWeight: 600,
  borderRadius: 2,
  px: 3,
  py: 1.25,
  "&:hover": {
    bgcolor: "primary.dark",
  },
};

// Botão secundário (outlined) para ações de cancelamento/fechar
export const adminButtonOutlinedSx: SxProps = {
  borderColor: "primary.main",
  color: "primary.main",
  fontWeight: 500,
  borderRadius: 2,
  px: 3,
  py: 1.25,
  "&:hover": {
    bgcolor: "primary.main",
    color: "primary.contrastText",
  },
};